import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const OpenedWithBackground = () => (
  <ImageIcon src={Images.OpenedWithBg} alt="empty-data/" />
);

export default OpenedWithBackground;
